import * as actions from "./actions";
import * as mutations from "./mutations";

export default {
  namespaced: true,

  state: {
    chartsViewBlocks:{
      1:'all_tasks',
      2:'time_chart',
      3:'tags_chart',
      4:null,
    },
    activeTasks: {},
    allActiveTasks: null,
    activeTasksCounter: 0,
    activeMeetingsCounter: 0,
    activeTimer: {},
    chartDataToTable: {},
    categories: [],
    getFetchTasks: {},
    queryForCharts: {},
    preOpenTaskFromChart: false,
    preOpenMeetingFromMsgCenter: false,
    preOpenMainTaskWindowFromHeader: false,
    resetQuery: false,
    resetTags: false,
    stopTimer: false,
    topThreeUsersFromLast100: [],
    topFiveTagsFromLast100: [],
    tasks: {},
    taskDictionaries: {},
    tasksFilteringVuexObj: {},
    openRepForEmails:false
  },

  actions,
  mutations,

  getters: {
    getOpenRepForEmails: state => {
      return state.openRepForEmails;
    },
    getResetQuery: state => {
      return state.resetQuery;
    },

    getTasks: state => {
      return state.tasks;
    },
    getActiveTasks: state => {
      return state.activeTasks;
    },
    getAllActiveTasks: state => {
      return state.allActiveTasks;
    },

    getActiveTasksCounter: state => {
      return state.activeTasksCounter;
    },
    getActiveMeetingsCounter: state => {
      return state.activeMeetingsCounter;
    },
    getChartQueryObject: state => {
      return state.queryForCharts;
    },
    getActiveTimer: state => {
      return state.activeTimer;
    },
    getTopThreeUsersFromLast100: state => {
      return state.topThreeUsersFromLast100;
    },
    getCategories: state => {
      return state.categories;
    }
  }
};
